import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'block', 'info', 'radio' ]

  initialize() {
    this.update()
    if(this.descriptionTarget())
      this.descriptionTarget().dataset.scroll = true
  }

  descriptionTarget(){
    return document.getElementById('charityDescription');
  }

  update(){
    if(this.radioTarget.checked) {
      this.blockTarget.classList.add('charity-active');
      if(this.descriptionTarget())
        this.descriptionTarget().innerHTML = this.infoTarget.innerHTML
      this.scrollToSelectedCharity()
    } else {
      this.blockTarget.classList.remove('charity-active');
    }
  }

  trigger_update_all(){
    document.querySelectorAll('[data-controller*="charity-item"] [data-charity-item-target="radio"]').forEach((element, _) => {
      element.dispatchEvent(new Event('change', { 'bubbles': true }));
    })
  }

  scrollToSelectedCharity() {
    if(this.descriptionTarget() && this.descriptionTarget().dataset.scroll) {
      this.descriptionTarget().scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.descriptionTarget().dataset.scroll = '';
    }
  }

  select(){
    this.radioTarget.checked = true;
    this.trigger_update_all();
  }
}
